<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" routerLink="/account/notification-roles">Notification Roles</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button mat-raised-button color="primary" (click)="onEditNotificationRole()" class="m-1 mr-2" id="add" matTooltip="Create a new notification role."
          *ngIf="canCreate">
          <mat-icon>add</mat-icon>
          New Notification Role
        </button>

        <mat-menu #appMenu="matMenu">
          <button mat-menu-item (click)="listDataSource.selectAllToggle()">
            <mat-icon *ngIf="listDataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!listDataSource.isAllSelected()">select_all</mat-icon>
            {{ listDataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
          </button>

          <button mat-menu-item (click)="onDeleteSelectedNotificationRoles()" [disabled]="!listDataSource.selection.hasValue()">
            <mat-icon>delete</mat-icon> Delete Selected
          </button>
        </mat-menu>

        <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect notification roles." style="min-width: 120px"
          *ngIf="canDelete">
          <mat-icon>more_vert</mat-icon>
          List Menu
        </button>
      </span>

      <ng-container *ngIf="canView">
        <form class="form-inline mx-1 my-0" (ngSubmit)="listDataSource.getData(true)">
          <input
            class="form-control ml-0 mr-2 my-1"
            type="search"
            [(ngModel)]="listDataSource.search"
            name="search"
            placeholder="Search"
            aria-label="Search"
            id="search-input"
            matTooltip="Search for notification roles." />

          <button
            mat-raised-button
            color="secondary"
            type="submit"
            class="mx-0 my-1"
            id="search-button"
            matTooltip="Click this button to run the current search.">
            <mat-icon>search</mat-icon> Search
          </button>
        </form>
      </ng-container>
    </div>
  </nav>

  <div class="alert alert-warning m-2" *ngIf="!canView">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    You do not have permission to view notification roles.
    <span *ngIf="canCreate">You can still create new notification roles using the button above.</span>
    <span *ngIf="!canCreate">Please contact your administrator to request access.</span>
  </div>

  <div class="mat-elevation-z8 scroll-box" *ngIf="canView">
    <mat-paginator #paginator1 [length]="listDataSource?.total | async" [pageSize]="listDataSource.limit" [pageSizeOptions]="listDataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

    <table mat-table [dataSource]="listDataSource" matSort matSortActive="date_created" matSortDirection="desc" matSortDisableClear>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox (change)="$event ? listDataSource.selectAllToggle() : null"
            [checked]="listDataSource.selection.hasValue() && listDataSource.isAllSelected()"
            [indeterminate]="listDataSource.selection.hasValue() && !listDataSource.isAllSelected()"
            [matTooltip]="(listDataSource.isAllSelected() ? 'Deselect' : 'Select') + ' all notification roles.'">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
            (change)="$event ? listDataSource.selection.toggle(row.id) : null"
            [checked]="listDataSource.selection.isSelected(row.id)"
            [matTooltip]="(listDataSource.selection.isSelected(row.id) ? 'Deselect' : 'Select') + ' this notification role.'">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by id.">
          ID #
        </th>
        <td mat-cell *matCellDef="let notification_role">
          {{ notification_role.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by name.">
          Name
        </th>
        <td mat-cell *matCellDef="let notification_role">
          {{ notification_role.name | titlecase  }}
        </td>
      </ng-container>

      <ng-container matColumnDef="system_notifications_count">
        <th mat-header-cell *matHeaderCellDef matTooltip="The count of enabled notifications.">
          Enabled Notifications
        </th>
        <td mat-cell *matCellDef="let notification_role">
          <span style="text-decoration: underline;" [matTooltip]="getNotificationRoleSystemNotificationsForTooltip(notification_role)">
            {{ notification_role.system_notifications_count  }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="sites_count">
        <th mat-header-cell *matHeaderCellDef matTooltip="The count of associated sites.">
          Sites
        </th>
        <td mat-cell *matCellDef="let notification_role">
          <span *ngIf="canViewSites" style="text-decoration: underline;" [matTooltip]="getNotificationRoleSitesForTooltip(notification_role)">
            {{ notification_role.sites_count }}
          </span>
          <span *ngIf="!canViewSites">
            {{ notification_role.sites_count }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="users_count">
        <th mat-header-cell *matHeaderCellDef [matTooltip]="'The count of associated ' + utils.getLangTerm('employees.plural', 'Employees').toLowerCase() + '.'">
          {{ utils.getLangTerm('employees.plural', 'Employees') }}
        </th>
        <td mat-cell *matCellDef="let notification_role">
          <span *ngIf="canViewEmployees" style="text-decoration: underline;" [matTooltip]="getNotificationRoleUsersForTooltip(notification_role)">
            {{ notification_role.users_count }}
          </span>
          <span *ngIf="!canViewEmployees">
            {{ notification_role.users_count }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="is_active">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by active status.">
          Is Active
        </th>
        <td mat-cell *matCellDef="let notification_role">
          {{ notification_role.is_active ? 'Yes' : 'No'  }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by creation data.">
          Created At
        </th>
        <td mat-cell *matCellDef="let notification_role">
          {{ notification_role.date_created ? ((notification_role.date_created * 1000) | timezoneConvertMedium) : '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date_modified">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by modified date.">
          Updated At
        </th>
        <td mat-cell *matCellDef="let notification_role">
          {{ notification_role.date_modified ? ((notification_role.date_modified * 1000) | timezoneConvertMedium) : '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="180"></th>

        <td mat-cell *matCellDef="let notification_role">
          <button type="button" mat-button (click)="onEditNotificationRole(notification_role.id)"
            *ngIf="canEdit">
            Edit
          </button>

          <button type="button" mat-button (click)="onDeleteNotificationRole(notification_role.id, $event)"
            *ngIf="canDelete">
            Delete
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
    </table>

    <mat-paginator #paginator2 [length]="listDataSource?.total | async" [pageSize]="listDataSource.limit" [pageSizeOptions]="listDataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>
